// extracted by mini-css-extract-plugin
module.exports = {"SideDrawer":"SideDrawer_SideDrawer__yi1ld","Open":"SideDrawer_Open__3D1ah","Close":"SideDrawer_Close__2QfI6","Logo":"SideDrawer_Logo__1VYrs"};